import './selenium.css'
import React, {useEffect, useState} from 'react';
import RecordButton from "./RecordButton";
import DownloadButton from "./DownloadButton";
import GENERATOR from "../generator/Generator";
import {mygaSession} from "../../scripts/myga-session";
import {NassauLog} from "../../scripts/myga-utils";

const TestingToolbar = props => {
  const [recording, setRecording] = useState(GENERATOR.getTestModeEnabled())

  // Listen to the setting of test mode in the myga session
  useEffect(() => {
    mygaSession.eventEmitter.on(GENERATOR.TEST_EVENTS.SET_TEST_MODE, () => {
      NassauLog(`GENERATOR.getTestModeEnabled(): ${GENERATOR.getTestModeEnabled()}`);
      setRecording(GENERATOR.getTestModeEnabled());
    })

    // clean up event emitter
    return () => {
      mygaSession.eventEmitter.off(GENERATOR.TEST_EVENTS.SET_TEST_MODE)
    }
  }, [])

  return (
    <div className={'toolbar'}>
      <DownloadButton recording={recording}/>
      <RecordButton recording={recording} updatePage={props.updatePage}/>
    </div>
  )
}

export default TestingToolbar;